import styled from '@emotion/styled';
import { Modal, Typography } from '@innovamat/glimmer-components';
import { useTranslation } from 'react-i18next';

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

type Props = {
  isOpen: boolean;
  isPending?: boolean;
  onClose?: () => void;
  onConfirm?: () => void;
};

function DisableHomeAccessModal({
  isOpen,
  isPending,
  onClose,
  onConfirm,
}: Props): JSX.Element {
  const { t } = useTranslation();

  return (
    <Modal
      buttons={[
        {
          children: t('students.home-access.configuration.disable'),
          loading: isPending,
          variant: 'accent',
          onClick: onConfirm,
        },
        {
          children: t('confirmModal.action.cancel'),
          variant: 'tertiary',
          onClick: onClose,
        },
      ]}
      isOpen={isOpen}
      modalWidth={692}
      semantic={{ type: 'warning', text: t('common.modal.important') }}
      title={t('students.home-access-popup.warning.title')}
      onClose={onClose}
    >
      <ModalContent>
        <Typography.Body1>
          {t('students.home-access-popup.warning.description')}
        </Typography.Body1>
      </ModalContent>
    </Modal>
  );
}

export { DisableHomeAccessModal };
